export const STUDENT_QA = {
  GET_ALL_QUESTIONS: "GET_ALL_QUESTIONS",
  GET_ALL_ANSWERS: "GET_ALL_ANSWERS"
};
